import JsTabs from "js-tabs";
import config from "./Config/config";

require('./base');

import Order from "./Components/basket/order";

require('./Components/suggestions');

import {calculator} from "./Components/basket/Calculator/DefaultCalculator";
import {getCartData} from "./Components/basket/get-cart-data";
import updateItem from "./Components/basket/updateItem";
import {deleteFromBasket} from "./Components/basket/deleteFromBasket";

import events from "./base";
import {changeInputFile} from "./Components/input-file";
import Agent from "./Components/Core/agent";

new Order(events);

const state = {
    index: '',
    deliveryIndex: '',
    isUpdatedDelivery: true,
    coupon: '',
    deliveryPrice: 0,
    packingPrice: 0,
    PaymentVariant: '',
    carData: undefined
};

const updaterCartInfo = () => {
    if (!state.carData) {
        getCartData(state.coupon, state.PaymentVariant).then(e => {
            state.carData = e;
            events.dispatch(config.listeners.basket.added, state.carData, state.deliveryPrice, state.packingPrice, state.PaymentVariant);
        });
    } else {
        events.dispatch(config.listeners.basket.added, state.carData, state.deliveryPrice, state.packingPrice, state.PaymentVariant);
    }
};

const setCartData = cartData => {
    state.carData = cartData;
    updaterCartInfo();
};

const setCartDataWitchClearDeliveryAndPackingPrice = cartData => {
    setCartData(cartData);
};

let calc = calculator(events);
calc.init('section.basket .js_item');

events.addListener('item.deleted', null, calc.delete.bind(calc));
events.addListener('item.deleted', null, (e, j) => setCartDataWitchClearDeliveryAndPackingPrice(j));

events.addListener('paper.update', null, (element, data) => updateItem(element, data, state.coupon, state.PaymentVariant, events));

events.addListener('item.updated', null, e => setCartDataWitchClearDeliveryAndPackingPrice(e));

document.querySelectorAll('.js_del_good_cart')
    .forEach(item => item.addEventListener('click', event => {
        deleteFromBasket(event, state.coupon, state.PaymentVariant, events);
    }));

document.querySelectorAll('.js_delivery_tab').forEach(item => {
    item.addEventListener('click', () => {
        document.querySelector('[name="delivery_variant"]').value = item.dataset.id;
    });
});

document.querySelectorAll('.js_set_payment').forEach(item => {
    item.addEventListener('click', () => {
        document.querySelector('[name="payment_variant"]').value = item.dataset.id;
    });
});


// const setPaymentVariant = () => {
//     let currentPaymentVariant = state.PaymentVariant;
//     let organization = document.querySelector('[name="organization"]');
//
//     document.querySelector('[name="payment_variant"]').value = organization.value.trim().length ?
//         document.querySelector('[name="payment_transfer"]').value :
//         document.querySelector('[name="payment_agreement"]').value;
//
//     state.PaymentVariant = document.querySelector('[name="payment_variant"]').value;
//
//     if (currentPaymentVariant !== state.PaymentVariant) {
//         state.carData = undefined;
//         updaterCartInfo();
//     }
// };

// let organizationTimer;
// document.querySelectorAll('[name="organization"]').forEach(item => {
//     item.addEventListener('input', () => {
//         clearTimeout(organizationTimer);
//         organizationTimer = setTimeout(setPaymentVariant, 1000);
//     });
// });

updaterCartInfo();


document.querySelectorAll('input[type="file"]').forEach(el => {
    if (el.getAttribute('type') === 'file') {
        el.addEventListener('change', () => changeInputFile(el));
    }
});


document.querySelectorAll('input[name="lizing"]')
    .forEach(item => item.addEventListener('change', () => {
        Agent.post('api/v1/basket/item/lizing', JSON.stringify({lizing: item.checked, id: item.closest('.js_item').dataset.basket_id}),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json()).then(data => {

        }).catch(e => console.log(e));
    }));


document.querySelectorAll('input[name="kp"]')
    .forEach(item => item.addEventListener('change', () => {
            Agent.post('api/v1/basket/item/kp', JSON.stringify({kp: item.checked, id: item.closest('.js_item').dataset.basket_id}),
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(response => response.json()).then(data => {

            }).catch(e => console.log(e));
    }));


let d = new Date();
let loc = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds());
const inputTimeZone = document.createElement('input');
inputTimeZone.type = 'hidden';
inputTimeZone.value = ((document.body.dataset.time - loc / 1000) / 3600).toFixed(0);
inputTimeZone.name = "user_data_time_zone";
document.body.append(inputTimeZone);